var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionTransportFunicular({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.85 6.145A4 4 0 0 0 2 9.975v6.68a1 1 0 0 0 1.287.959l18-5.4a1 1 0 0 0 .713-.958V3.688a2 2 0 0 0-2.575-1.916L4.851 6.145ZM16 9.712l4-1.2v-3.48a1 1 0 0 0-1.287-.958L16 4.888v4.824Zm-6-3.024 4-1.2v6.824l-4 1.2V6.688ZM4.713 8.274 8 7.288v4.824l-4 1.2v-4.08a1 1 0 0 1 .713-.958Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.958 15.313a1 1 0 0 1-.67 1.245l-18 5.4a1 1 0 1 1-.575-1.916l3.517-1.055a1.996 1.996 0 0 1-1.78-.722l3.54-1.062a2.001 2.001 0 0 1-1.087 1.582l11.328-3.398a1.996 1.996 0 0 1-1.78-.722l3.539-1.062a2 2 0 0 1-1.088 1.582l1.81-.543a1 1 0 0 1 1.246.67Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionTransportFunicular);
export default __webpack_public_path__ + "static/media/ic_action_transport_funicular.028ef3f4649a0cdb641d6f612a138008.svg";
export { ForwardRef as ReactComponent };